import type { SettingsSubComponentProps } from '@carboncopyco/components';
import {
  SettingMainItemsKeys,
  SettingsSubKeys,
} from '@carboncopyco/types/desktop/appSettings';
import { InputText, TextBase } from '@carboncopyco/ui';
import { useState } from 'react';
import { HeaderBlock } from './HeaderBlock';

const BrowserSettings = ({ saveData, getValue }: SettingsSubComponentProps) => {
  const [inputValue, setInputValue] = useState<string | undefined>(
    getValue(SettingsSubKeys.BrowserAddress)
  );

  return (
    <div className="flex flex-col grow">
      <HeaderBlock
        label={SettingMainItemsKeys.BrowserSettings}
        description="Customize your desktop app like you would your internet browser."
      />
      <div className="flex-col flex gap-2.5">
        <div>
          <TextBase
            label="Default browsing website"
            color="text-ds-natural-600"
          />
        </div>
        <InputText
          value={inputValue}
          onChange={(event) => {
            const newValue = event.currentTarget.value.trim();
            saveData(SettingsSubKeys.BrowserAddress, newValue, setInputValue);
          }}
          placeholder="Enter browser address"
        />
      </div>
    </div>
  );
};

export default BrowserSettings;
